import * as Sentry from '@sentry/react'
import './App.css'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuth } from './AuthContext.jsx'
import { initAnalytics, trackPageView } from './analytics.js'
import Login from './pages/Login.jsx'
import Dashboard from './pages/Dashboard.jsx'
import Chat from './pages/Chat.jsx'
import Reseller from './pages/Reseller.jsx'
import Success from './pages/Success.jsx'
import Cancel from './pages/Cancel.jsx'
import Privacy from './pages/Privacy.jsx'
import Terms from './pages/Terms.jsx'
import CookiePolicy from './pages/CookiePolicy.jsx'
import AuthCallback from './pages/AuthCallback.jsx'
import TawkWidget from './components/TawkWidget.jsx'
import CookieBanner from './components/CookieBanner.jsx'

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <div className="page">Loading...</div>
  if (!user) return <Navigate to="/" replace />
  return children
}

function App() {
  const { user, loading } = useAuth()
  const location = useLocation()

  useEffect(() => { initAnalytics() }, [])
  useEffect(() => { trackPageView(location.pathname) }, [location.pathname])

  useEffect(() => {
    function updateAppHeight() {
      const h = window.visualViewport?.height ?? window.innerHeight
      document.documentElement.style.setProperty('--app-height', `${h}px`)
    }
    updateAppHeight()
    window.visualViewport?.addEventListener('resize', updateAppHeight)
    window.addEventListener('resize', updateAppHeight)
    return () => {
      window.visualViewport?.removeEventListener('resize', updateAppHeight)
      window.removeEventListener('resize', updateAppHeight)
    }
  }, [])

  return (
    <>
    <TawkWidget />
    <CookieBanner />
    <Sentry.ErrorBoundary fallback={<div className="page">Something went wrong.</div>} showDialog>
    <Routes>
      <Route
        path="/"
        element={
          loading ? <div className="page">Loading...</div> :
          user ? <Navigate to="/chat" replace /> :
          <Login />
        }
      />
      <Route path="/join" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reseller"
        element={
          <ProtectedRoute>
            <Reseller />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat"
        element={
          <ProtectedRoute>
            <Chat />
          </ProtectedRoute>
        }
      />
      <Route path="/success" element={<Success />} />
      <Route path="/cancel" element={<Cancel />} />
      <Route path="/reseller/success" element={<Navigate to="/reseller" replace />} />
      <Route path="/reseller/cancel" element={<Navigate to="/dashboard" replace />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
    </Sentry.ErrorBoundary>
    </>
  )
}

export default App
